import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "data-cy": "view-alarm-logs",
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$t('AlarmLogs.header.title'),
      "subtitle": _vm.$t('AlarmLogs.header.description')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "data-cy": "account-filter",
            "multiple": ""
          },
          on: {
            "change": _vm.accountSelectionChanged,
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        })];
      },
      proxy: true
    }])
  }), _vm.accountFilterReady ? _c('core-alarm-logs-list', {
    attrs: {
      "accounts": _vm.selectedAccountIds
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };